document.addEventListener('DOMContentLoaded', function (event) {
    const {
        OverlayScrollbars,
        ScrollbarsHidingPlugin,
        SizeObserverPlugin,
        ClickScrollPlugin
    } = OverlayScrollbarsGlobal;

    OverlayScrollbars.plugin(ClickScrollPlugin);

    document.querySelectorAll('figure.table').forEach(function (table) {
        const osInstance = OverlayScrollbars(table, {
            scrollbars: {
                clickScroll: true,
                dragScroll: true
            }
        });
    });
});